import { createAction, props } from '@ngrx/store';
import {Venue} from '@emm/core/models/venue.model';
import {Consumer} from '@emm/core/models/consumer.model';
import {ItemSummary} from '@emm/core/models/item-summary.model';



export enum ItemsAction {
    Load = '[Menu Tree] Load Items',
    LoadByVenue = '[Menu Tree] Load Venue Items',
    LoadSuccess = '[Menu API] Load Items Success',
    LoadFailure = '[Menu API] Load Items Failure',
    Select = '[Menu Tree] Select Item',
}

export const ItemsActions = {
    load: createAction(ItemsAction.Load),
    loadByVenue: createAction(ItemsAction.LoadByVenue, props<{ venue: Venue, consumer: Consumer}>()),
    loadSuccess: createAction(ItemsAction.LoadSuccess, props<{ items: ItemSummary[] }>()),
    loadFailure: createAction(ItemsAction.LoadFailure, props<{ error: any }>()),
    select: createAction(ItemsAction.Select, props<{ item: ItemSummary; dispatchReload: boolean }>()),
};

export const AsyncActions = {
    loadActions: [ItemsActions.load],
    successActions: [ItemsActions.loadSuccess],
    errorActions: [ItemsActions.loadFailure]
};
